export default "/_next/static/images/27/createLeadBackground-27e36d14f26a02cf3f4ff28053651b34.jpg";